import { CLEAR, MESSAGES_SHOW, MESSAGES_HIDE } from './types';

export const clear = () => ({ type: CLEAR });
export const messagesShow = (text, type, permanent) => ({ type: MESSAGES_SHOW, payload: { text, type, permanent } });
export const messagesHide = () => ({ type: MESSAGES_HIDE });
